module.exports = __webpack_public_path__ + "img/logo.2804cdea.png";